module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAATpJREFUOE/dlL8vBEEUxz+zhWwkxJ+gEZVC6BS314jOj0ZnXEVBlKISlSglElRndBpcJ5pdhY4oVKLxJwiJbBQ7Mrc3ft3u7ZDVmHLmzed935vvPEHJS7TxRva76ekaB28Q8HPyxZDc8fx6zvXCy+eYr8CKmsZjB7hFcwPEOUAfwTAwRMISF/LExn0ADUywDWKGaO7KqRPB4SjoYzQrFpoCTZm9/j1aTDrDbEYDFbrBUzxgyk+BQX0K4S0SyolMZUG9v7kf1R4yz6vqDJ3sEdVOW0C1CvQRybXMCxW1jEATSdPf9hWoTeCRSG5Z4HqqQG449e57UKDe77sBAzXbSniUo/DHwM4V/ELhPwR2tk31YKz5GOH8paNtCoxd5CVjbNgllI0/+npGQanDwZZU6viy0FIHbFHzHc7fANpgqxWjPyiUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person06.png
// module id = k1O0
// module chunks = 15